var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-diff-viewer"},[(!_vm.hasError)?_c('div',{ref:"mount",staticClass:"text-diff-viewer-mount"}):_c('div',{staticClass:"mt-2 red--text text--darken-2"},[_c('i',[_vm._v("Differenzansicht konnte nicht geladen werden.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }